export default "__VITE_ASSET__DMK9$8u7__"